// ----------------------------------------------------------------------------
// Product Form Extension: Variant Url Updater
// ----------------------------------------------------------------------------
// Updates the browser URL dynamically to reflect the selected variant ID
// ----------------------------------------------------------------------------
// Event Listeners:
// - 'productForm:option:changed' → Listens for variant option changes to update the URL
// ----------------------------------------------------------------------------
// Key Data Mutations:
// - Updates the browser URL by adding the variant ID to the URL
// ----------------------------------------------------------------------------
// Gotchas:
// - Depends on Shopify's `getUrlWithVariant` function to generate the new URL
// - If no variant is selected (e.g., the option combination is unavailable),
//   it exits without modifying the URL (i.e. doesn't clear the previous variant selection)
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
import { getUrlWithVariant } from '@shopify/theme-product-form';

// -------------------------------------
// Event Listeners
// -------------------------------------

iamotaEventHandler.subscribe('productForm:option:changed', _ref => {
  var iamProductForm = _ref.iamProductForm;
  // Retrieve the current selected variant from the product form
  var variant = iamProductForm.getCurrentVariant();

  // Exit if no variant is selected (typically the selected option combination isn't available)
  if (!variant) return;

  // Generate the URL with the variant ID
  var url = getUrlWithVariant(window.location.href, variant.id);

  // Update the browser's history with the new URL
  window.history.replaceState({
    path: url
  }, '', url);
}, {
  source: "product-form--updateUrl.js"
});